import { render, staticRenderFns } from "./whiteUfw.vue?vue&type=template&id=5d006301&scoped=true"
import script from "./whiteUfw.vue?vue&type=script&lang=js"
export * from "./whiteUfw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d006301",
  null
  
)

export default component.exports